import type { TranslateDictionary } from './en.js';

export const Sl: TranslateDictionary = {
  'Start airplay': 'Začni AirPlay',
  'Stop airplay': 'Ustavi AirPlay',
  Audio: 'Zvok',
  Captions: 'Podnapisi',
  'Enable captions': 'Pokaži podnapise',
  'Disable captions': 'Skrij podnapise',
  'Start casting': 'Začni predvajanje',
  'Stop casting': 'Ustavi predvajanje',
  'Casting to {device}': 'Predvajanje na {device}',
  'Enter fullscreen mode': 'Povečaj',
  'Exit fullscreen mode': 'Skrči',
  Mute: 'Utišaj',
  Unmute: 'Vklopi zvok',
  'Enter picture in picture mode': 'Omogoči način slika-v-sliki',
  'Exit picture in picture mode': 'Onemogoči način slika-v-sliki',
  Play: 'Predvajaj',
  Pause: 'Pavza',
  'Playback rate': 'Hitrost predvajanja',
  'Playback rate {playbackRate}': 'Hitrost predvajanja {playbackRate}',
  Quality: 'Kvaliteta',
  'Seek backward': 'Nazaj',
  'Seek forward': 'Naprej',
  Settings: 'Nastavitve',
  Auto: 'Samodejno',
  'audio player': 'predvajalnik zvoka',
  'video player': 'predvajalnik videa',
  volume: 'Glasnost',
  seek: 'Išči',
  'closed captions': 'Podnapisi',
  'current playback rate': 'trenutna hitrost predvajanja',
  'playback time': 'čas predvajanja',
  'media loading': 'nalaganje medijev',
  settings: 'Nastavitve',
  'audio tracks': 'zvočne sledi',
  quality: 'Kvaliteta',
  play: 'predvajaj',
  pause: 'pavza',
  mute: 'utišaj',
  unmute: 'vklopi zvok',
  'chapter: {chapterName}': 'poglavje: {chapterName}',
  live: 'v živo',
  Off: 'Izklopljeno',
  'start airplay': 'začni AirPlay',
  'stop airplay': 'ustavi AirPlay',
  'start casting': 'začni predvajanje',
  'stop casting': 'ustavi predvajanje',
  'enter fullscreen mode': 'povečaj',
  'exit fullscreen mode': 'skrči',
  'enter picture in picture mode': 'omogoči način slika-v-sliki',
  'exit picture in picture mode': 'onemogoči način slika-v-sliki',
  'seek to live': 'pojdi na v živo',
  'playing live': 'predvajanje v živo',
  'seek back {seekOffset} seconds': 'nazaj {seekOffset} sekund',
  'seek forward {seekOffset} seconds': 'naprej {seekOffset} sekund',
  'Network Error': 'Omrežna napaka',
  'Decode Error': 'Napaka dekodiranja',
  'Source Not Supported': 'Vir ni podprt',
  'Encryption Error': 'Napaka šifriranja',
  'A network error caused the media download to fail.':
    'Omrežna napaka je povzročila neuspeh prenosa medija.',
  'A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.':
    'Napaka medija je povzročila prekinitev predvajanja. Medij je lahko pokvarjen ali vaš brskalnik ne podpira te oblike.',
  'An unsupported error occurred. The server or network failed, or your browser does not support this format.':
    'Prišlo je do nepodprte napake. Strežnik ali omrežje je odpovedalo, ali vaš brskalnik ne podpira te oblike.',
  'The media is encrypted and there are no keys to decrypt it.':
    'Medij je šifriran in ni ključev za dešifriranje.',
  'This video is not available.': 'Ta video ni na voljo.',
  'This video could not be found.': 'Tega videa ni bilo mogoče najti.',
};
